import React, { useState, useEffect } from "react";
import { Table, Container, Input, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
/*import { PieChart, Pie } from 'recharts';*/
/*import { PieChart, Pie, Cell, Tooltip } from "recharts";*/
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
/*import { Pie } from 'react-chartjs-2';*/
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
import CreateTableComponent from "../../share/CreateTableComponent";
// import { FaSistrix } from "react-icons/fa";
import "../../share/form.css"
import "../../share/modal.css"
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2"
export function Report62Component() {

    const [thR62Selected, setR62Selected] = React.useState("4-01");
    const [Re62data, setRe62data] = useState([]);
    const [R62detail, setR62detail] = useState([]);
    const [R62detailfilter, setR62detailfilter] = useState([]);
    const [openModalForm, setOpenModalForm] = useState(false);

    async function getR62detail() {
        const formData = new FormData();
        formData.append("thYear", thR62Selected);
        // console.log("1234", thR62Selected);
        const res62 = await fetch("/api/Support/getReport62Detail", {
            method: 'POST',
            body: formData
        })
        const datar62detail = await res62.json()
        setR62detail(datar62detail.dataenum);
        // console.log(Re62data)
    }

    console.log("R62detailfilter", R62detailfilter);

    const modalToggleExtendCourse = (value) => {
        setOpenModalForm(!openModalForm);
        // console.log("idmodal", value);

        // console.log("thR62Selected", thR62Selected.split("-"));


        // console.log("R62detail", R62detail);
        setR62detailfilter(R62detail.filter(
            (item) => item.subSupportReportTypeId === value
        ))

        // if (value == 1) {
        //     setR62detailfilter(R62detail.filter(
        //         (type) => type.subSupportReportTypeId === "02"
        //     ))

        // }
        // if (value == 2) {
        //     setR62detailfilter(R62detail.filter(
        //         (type) => type.subSupportReportTypeId === "03"
        //     ))

        // }
        // if (value == 3) {
        //     setR62detailfilter(R62detail.filter(
        //         (type) => type.subSupportReportTypeId === "04"
        //     ))

        // }
        // if (value == 4) {
        //     setR62detailfilter(R62detail.filter(
        //         (type) => type.subSupportReportTypeId === "05"
        //     ))

        // }


    }
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNewn BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }

    async function getR62() {
        const formData = new FormData();
        formData.append("thYear", thR62Selected);
        const res62 = await fetch("/api/Support/getR62", {
            method: 'POST',
            body: formData
        })
        const Re62data = await res62.json()
        setRe62data(Re62data.dataenum);
        // console.log(Re62data)


    }



    useEffect(() => {
        getR62()
        getR62detail()
    }, [thR62Selected])

    let sumAmtBorrowCompany = Re62data.reduce(function (prev, current) {
        return prev + +current.amount
    }, 0);

    var sum100 = 0;
    if (sumAmtBorrowCompany != 0) {
        let sum100 = sumAmtBorrowCompany / sumAmtBorrowCompany * 100
    }







    // const data = [Re62data];
    // console.log(data);
    const COLORS = ["#48C9B0", "#5DADE2", "#F0B27A", "#AF7AC5", "#DE3163", "#40E0D0", "#CCCCFF", "#BDC3C7", "#F1948A", "#F1C40F"];

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active) {
            return (
                <div
                    className="custom-tooltip"
                    style={{
                        backgroundColor: "#ffff",
                        padding: "5px",
                        border: "1px solid #cccc"
                    }}
                >
                    <label>{`${payload[0].name} : ${payload[0].value} แห่ง`} </label>
                </div>
            );
        }
        return null;
    };

    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ที่', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รายการ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวน(แห่ง)', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ร้อยละ', fillColor: '#cccccc', bold: true, alignment: 'center' }]];
    //     Re62data.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.name1, alignment: 'center' }, { text: item.amount, alignment: 'center' }, { text: item.sum, alignment: 'center' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',

    //         content: [
    //             { text: thR62Selected, style: 'header', bold: true, alignment: 'center', fontSize: 16 },
    //             [{
    //                 table: {
    //                     widths: ['*','*', '*', '*'],
    //                     body: tablebody
    //                 },
    //             }]],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R62')
    // }



    const COLUMNSTRAIN = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน",
            accessor: "supportName",
        },
        {
            Header: "เลขที่คำขอ",
            accessor: "supportNo",
        },
        {
            Header: "ลงวันที่",
            accessor: "approveDate",
        },
        {
            Header: "หน่วยงานที่อนุมัติคำขอ",
            accessor: "deptName",
        },
        {
            Header: "จำนวนเงินที่ขอรับช่วยเหลือหรืออุดหนุน",
            accessor: "amount",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },

    ]

    return (
        <Container>
            <div>
                <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <Input
                        style={{ borderColor: "#130558", width: "100%", paddingTop: '0px', fontSize: '1.75rem' }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={thR62Selected}
                        onChange={(e) => {
                            setR62Selected(e.target.value)
                        }}
                    >
                        <option defaultValue value="1-01">
                            ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงานนำเงินอุดหนุนที่ได้รับไปส่งเสริมการพัฒนาฝีมือแรงงาน (ประกาศข้อ 4)
                        </option>
                        <option value="4-01">
                            ผู้ประกอบกิจการนำเงินอุดหนุนที่ได้รับไปส่งเสริมการพัฒนาฝีมือแรงงาน (ประกาศข้อ 6)
                        </option>
                        <option value="5-01">
                            ผู้ประกอบกิจการนำเงินอุดหนุนที่ได้รับไปส่งเสริมการพัฒนาฝีมือแรงงาน (ประกาศข้อ 7)
                        </option>
                        <option value="7-01">
                            ผู้ประกอบกิจการนำเงินอุดหนุนที่ได้รับไปส่งเสริมการพัฒนาฝีมือแรงงาน (ประกาศข้อ 9)
                        </option>
                        <option value="8-01">
                            ผู้ประกอบกิจการนำเงินอุดหนุนที่ได้รับไปส่งเสริมการพัฒนาฝีมือแรงงาน (ประกาศข้อ 10)
                        </option>
                        <option value="3-01">
                            ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงานนำเงินอุดหนุนที่ได้รับไปส่งเสริมการพัฒนาฝีมือแรงงาน (ประกาศข้อ 11)
                        </option>
                        <option value="1-02">
                            ประโยชน์ที่ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงานได้รับจากการดำเนินการพัฒนาฝีมือแรงงาน (ประกาศข้อ 4)
                        </option>
                        <option value="4-02">
                            ประโยชน์ที่ผู้ประกอบการได้รับจากการดำเนินการพัฒนาฝีมือแรงงาน (ประกาศข้อ 6)
                        </option>
                        <option value="5-02">
                            ประโยชน์ที่ผู้ประกอบการได้รับจากการดำเนินการพัฒนาฝีมือแรงงาน (ประกาศข้อ 7)
                        </option>
                        <option value="7-02">
                            ประโยชน์ที่ผู้ประกอบการได้รับจากการดำเนินการพัฒนาฝีมือแรงงาน (ประกาศข้อ 9)
                        </option>
                        <option value="8-02">
                            ประโยชน์ที่ผู้ประกอบการได้รับจากการดำเนินการพัฒนาฝีมือแรงงาน (ประกาศข้อ 10)
                        </option>
                        <option value="3-02">
                            ประโยชน์ที่ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงานได้รับจากการดำเนินการพัฒนาฝีมือแรงงาน (ประกาศข้อ 11)
                        </option>
                    </Input>

                </div>
                <center>
                    {/* <h3 className='text-center' style={{ lineHeight: 'inherit' }}></h3> */}
                    <PieChart width={1100} height={600}>
                        <Pie
                            data={Re62data}
                            color="#000000"
                            dataKey="amount"
                            nameKey="name1"
                            labelLine={false}
                            label={renderCustomizedLabel}
                            outerRadius={200}
                            fill="#8884d8"
                        >
                            {Re62data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip content={CustomTooltip} />
                        <Legend />
                    </PieChart>

                    {/* <Row>
                        <Col className='d-flex justify-content-end'>
                            <Button href={`api/Support/xlsxR62?thYear=${thR62Selected}`} download>.XLSX</Button>
                            <Button onClick={PrintPDF}>.PDF</Button>
                        </Col>
                    </Row> */}
                    <div className="d-flex align-items-center justify-content-end">
                        <Button className="btn1" href={`api/SupportReports/excelR62?thYear=${thR62Selected}`} download>EXCEL</Button>
                        <Button className="btn1" href={`api/SupportReports/excelR62Detail?thYear=${thR62Selected}`} download>EXCEL(Detail)</Button>
                    </div>

                    <Table className="styled-table" bordered striped hover>
                        <thead>
                            <tr>
                                <th rowSpan="3">
                                    ที่
                                </th>
                                <th rowSpan="3" className='text-center'>
                                    รายการ
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    จำนวน (แห่ง)
                                </th>
                                <th rowSpan="3" className=' text-center'>
                                    ร้อยละ
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {Re62data.length > 0 && Re62data.map((item, i) => (
                                <tr >

                                    <td className='text-center'>
                                        {i + 1}
                                    </td>
                                    <td className='text-start'>
                                        {item.name1}
                                    </td>

                                    <td className='text-center'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.subSupportReportTypeId} onClick={(e) => { modalToggleExtendCourse(e.target.id) }}>{item.amount}</p>
                                    </td>

                                    <td className='text-end'>
                                        {item.sum}
                                    </td>


                                </tr>

                            )) || <tr><td colSpan="6" className='text-center'>No Data</td></tr>}

                            <tr>
                                <th colSpan="2" className='text-end'>
                                    รวม
                                </th>
                                <td className='text-end'>
                                    {sumAmtBorrowCompany}
                                </td>
                                <td className='text-end'>
                                    {sum100}
                                </td>

                            </tr>
                        </tbody>

                    </Table>

                </center>


            </div>

            <Modal

                isOpen={openModalForm}
                toggle={modalToggleExtendCourse}
                // style={{ maxWidth: "600px", width: "100%" }}
                centered
                scrollable
                backdrop={'static'}
                keyboard={false}
                size="xl"

                className="modal-bordered"
            >
                <ModalHeader toggle={modalToggleExtendCourse} className="styled-modal text-center">
                    รายละเอียดข้อมูล
                </ModalHeader>
                <ModalBody >
                    <CreateTableComponent column={COLUMNSTRAIN} dataInput={R62detailfilter} showEntrie={true} showPage={true} />
                </ModalBody>
            </Modal>

        </Container>


    )

}

